<template>
  <div id="">
    <el-dialog :title="title" width="600px" :before-close="resetForm" :visible.sync="dialogFormVisible">
      <el-form ref="course" :model="course">
        <el-form-item label="课程名称：" :label-width="formLabelWidth" prop="courseName" :rules="[
            { required: true, message: '请输入课程名称', trigger: 'blur' }
          ]">
          <el-input v-model="course.courseName" autocomplete="off" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="课程编码：" :label-width="formLabelWidth" prop="courseCoding" :rules="[
            { required: true, message: '请输入课程编码', trigger: 'blur' }
          ]">
          <el-input v-model="course.courseCoding" autocomplete="off" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="排序编号：" :label-width="formLabelWidth" prop="courseNum" :rules="[
            { required: true, message: '序号不能为空' },
            { type: 'number', message: '序号必须为数字值' }
          ]">
          <el-input v-model.number="course.courseNum" autocomplete="off" maxlength="20"
            oninput="value=value.replace(/[^0-9]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="年级：" :label-width="formLabelWidth" prop="grade" :rules="[
            {
              type: 'array',
              required: true,
              message: '请至少选择一个年级',
              trigger: 'change'
            }
          ]">
          <el-checkbox-group v-model="course.grade">
            <el-checkbox v-for="item in gradeList" :key="item.gradeId"
              :label="item.gradeId + ''">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="resetForm">取 消</el-button>
        <el-button size="small" type="primary" @click="baocun">保 存</el-button>
      </div>
    </el-dialog>
    <!-- <span class="basisInformation">必修课程</span> -->
    <el-row :gutter="12">
      <el-col :span="18" class="col-header">
        <el-card shadow="never"> 必修课程</el-card>
      </el-col>

      <el-col :span="6" class="col-button">
        <el-button class="baocun" icon="el-icon-plus" type="primary" size="medium" @click="addCourse">新增必修课程</el-button>
      </el-col>
    </el-row>

    <!-- <el-divider></el-divider> -->
    <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      style="width: 100%" border stripe :data="subjectList">
      <el-table-column align="center" type="index" width="50" label="序号">
      </el-table-column>
      <el-table-column align="center" prop="name" label="课程名称">
      </el-table-column>
      <el-table-column align="center" prop="code" label="课程编码">
      </el-table-column>
      <el-table-column align="center" label="开设年级">
        <div slot-scope="scope">
          {{ gradeData(scope.row.grades) }}
        </div>
      </el-table-column>
      <el-table-column align="center" width="150" prop="sortNo" sortable label="排序">
      </el-table-column>
      <el-table-column align="center" prop="" label="操作">
        <!-- v-if="scope.row.schoolId !== 0" -->
        <div slot-scope="scope">
          <el-button type="text" :disabled="scope.row.schoolId == 0" size="small"
            @click="editCourse(scope.row)">编辑</el-button>
          <el-button type="text" size="small" class="left_btn delete_btn" :disabled="scope.row.schoolId == 0"
            @click="DeleteCourse(scope.row)">删除</el-button>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as homeApi from '@/api/home'
export default {
  data() {
    return {
      schoolId: localStorage.getItem('schoolIds'),
      dialogFormVisible: false,
      formLabelWidth: '100px',
      course: {
        id: '',
        courseName: '',
        courseCoding: '',
        grade: [],
        courseNum: ''
      },
      gradeList: [], //   年级列表
      subjectList: [], //课程信息列表
      title: ''
    }
  },
  created() {
    this.getSubjectList()
  },
  methods: {
    //   新增课程
    addCourse() {
      this.dialogFormVisible = true
      this.title = '添加课程'
    },
    baocun() {
      let that = this
      let params = {}
      if (this.title === '添加课程') {
        params = {
          code: that.course.courseCoding,
          grades: that.course.grade,
          name: that.course.courseName,
          schoolId: that.schoolId,
          sortNo: this.course.courseNum
        }
      } else {
        params = {
          code: that.course.courseCoding,
          grades: that.course.grade,
          name: that.course.courseName,
          schoolId: that.schoolId,
          sortNo: this.course.courseNum,
          id: this.course.id
        }
      }

      this.$refs.course.validate(valid => {
        if (valid) {
          homeApi.addSubject(params).then(res => {
            if (res.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.getSubjectList()
            }
            this.resetForm()
          })
        } else {
          return false
        }
      })
    },
    // 获取学校课程信息列表
    getSubjectList() {
      homeApi
        .subjectList({
          schoolId: this.schoolId
        })
        .then(res => {
          this.subjectList = res.data.data
          this.gradeClassList()
        })
    },
    // 获取学校年级列表
    gradeClassList() {
      homeApi
        .gradeClassList({
          schoolId: this.schoolId
        })
        .then(res => {
          this.gradeList = res.data.data
        })
    },
    // 年级数据处理
    gradeData(data) {
      let datas = data.split(',')
      let dataName = []
      for (let key in this.gradeList) {
        let idx = datas.indexOf(this.gradeList[key].gradeId + '')
        if (idx != -1) {
          dataName.push(this.gradeList[key].name)
        }
      }
      return dataName.join('，')
    },
    // 删除
    DeleteCourse(row) {
      this.$confirm(`确定删除${' ' + row.name + ' '}课程吗`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          homeApi.deleteSubject(row.id).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getSubjectList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 编辑
    editCourse(row) {
      this.dialogFormVisible = true
      this.title = '编辑课程'
      this.course.courseName = row.name
      this.course.courseCoding = row.code
      this.course.grade = row.grades.split(',')
      this.course.courseNum = row.sortNo
      this.course.id = row.id
    },
    // 数据初始化
    resetForm(from) {
      this.dialogFormVisible = false
      this.$refs.course.resetFields()
      this.course.courseName = ''
      this.course.courseCoding = ''
      this.course.grade = []
      this.course.courseNum = ''
      this.course.id = ''
    }
  }
}
</script>
<style scoped>
#app {
  position: relative;
}
.basisInformation {
  font-size: 16px;
  font-weight: 700;
}
.el-divider {
  margin-top: 18px;
  margin-bottom: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/schoolCourse.vue